(() => {
  const triggers = document.querySelectorAll('[data-machine-layout-trigger]');
  const layouts = document.querySelectorAll('[data-machine-layout]');
  if (!triggers.length || !layouts.length) return;

  function setActive(id) {
    triggers.forEach((trigger) => {
      const isActive = trigger.dataset.machineLayoutTrigger === id;
      trigger.classList.toggle('machine-features-hero__tab--active', isActive);
      trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    layouts.forEach((layout) => {
      const isActive = layout.dataset.machineLayout === id;
      if (isActive) {
        layout.removeAttribute('hidden');
      } else {
        layout.setAttribute('hidden', '');
      }
    });
    if (window.location.hash !== '#' + id) {
      history.replaceState(null, '', '#' + id);
    }
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      setActive(trigger.dataset.machineLayoutTrigger);
    });
  });

  const initial = window.location.hash.replace('#', '');
  if (initial && document.querySelector('[data-machine-layout="' + initial + '"]')) {
    setActive(initial);
  }
})();
